import React from "react";
import styled from "styled-components";
import Affiliates from "./Affiliates";
// import Map from "./Map";
// import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import bg from "../imgs/academy.jpg";
import "./Academy.scss";


const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto 350px;
  grid-template-rows: 1fr;
  margin-top: 10px;
  @media (max-width: 991px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }
`;

const AcademyBg = styled.div`
  grid-column-start: 2;
  grid-column-end: 3;
  background-image: url(${ bg });
  background-repeat: no-repeat;
  background-size: contain;
  height: 420px;
  @media (max-width: 991px) {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 3;
    background-size: cover;
  }
`;

const Info = styled.div`
  grid-column-start: 1;
  grid-column-end: 2;
  padding: 20px 20px 20px 0px;
  @media (max-width: 991px) {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
  }
`;

class Academy extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {};
  }
  componentDidMount() { }

  render()
  {

    /*
    const center_lat = 48.2028963;
    const center_lng = 16.3429201;
    const zoom = 15
    */

    return (
      <div className="academy">
        <h1 className="heading">Academy</h1>
        <div className="map">
          <iframe loading="lazy" allowfullscreen src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJUVl5X_IHbUcRpiT5og1jR3Q&key=AIzaSyAg3-gbY4s8mQDNJPrXMOYfD1C50L6Az9E"></iframe>
          {/*
            <MapContainer center={[center_lat, center_lng]} zoom={zoom} style={{ height: '30em', marginTop: '4em' }}>
              <TileLayer
                id='mapbox/streets-v11'
                url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              />
              <Marker position={[center_lat, center_lng]} />
            </MapContainer>
          */}
        </div>
        <Wrapper>
          <Info>
            <ul className="contact">
              <li>
                <span style={{ fontSize: 32 }}>Kandlgasse 18, Wien 1070</span>
              </li>
              <li><strong>+43 664 462 71 90</strong> &nbsp;&nbsp; (Monday to Friday from 12:00 to 16:00)</li>
              <li>
                <a href="mail:o.m.neto@hotmail.com">o.m.neto@hotmail.com</a>
              </li>
              <li>
                <a href="https://www.facebook.com/RGAVIENNA">Facebook</a>
              </li>
              <li>
                <a href="https://www.instagram.com/onetobjj/">Instagram</a>
              </li>
            </ul>
          </Info>
          <AcademyBg />
        </Wrapper>
        <Affiliates />
      </div>
    );
  }
}

export default Academy;
